import {
  AfterContentChecked,
  ChangeDetectorRef,
  Component,
  ElementRef,
  HostListener,
  OnDestroy,
  OnInit,
  ViewChild,
  ChangeDetectionStrategy
} from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { TabPosition } from '@progress/kendo-angular-layout';
import { Observable } from 'rxjs';
import { DataWithPagingMetadata } from '~/infrastructure/paging';
import { GridFieldAuthorization } from '~/models/administration/securityLevel';
import { UserSummary } from '~/models/administration/user';
import { Chart } from '~/models/chart/chart';
import { CustomFieldSummary } from '~/models/modules/customField';
import { GridFieldSummary } from '~/models/modules/gridField';
import { GridFieldTextSummary } from '~/models/modules/GridFieldText';
import { LocationSummary } from '~/models/modules/location';
import { BarcodeGeneratorsService } from '~/services/modules/stocks/barcode-generators';
import { CustomFieldsService } from '~/services/modules/stocks/custom-fields';
import { GridFieldsService } from '~/services/modules/stocks/gridField';
import { StockItemsService } from '~/services/modules/stocks/items';
import { LocationTypesService } from '~/services/modules/stocks/location-types';
import { SecurityService } from '~/services/security.service';
import { SharedService } from '~/services/sharedService';
import { ThemeManagerService } from '~/services/theme-manager';
import { GridLayoutManagerService } from '~/shared/components/grid/layout/grid-layout-manager';
import { LayoutManagerService, PORTAL_DATA } from '~/shared/components/layout/layout-manager';
import { LayoutComponent } from '~/shared/components/layout/layout.component';
import { PageState } from '~/shared/enums/stock-files.enum';
import { NoteComponent } from '~/shared/components/note/note.component';

import { AddressesService } from '~/services/modules/stocks/addresses';
import { FilesService } from '~/services/modules/stocks/files';
import { ComboBoxComponent, VirtualizationSettings } from '@progress/kendo-angular-dropdowns';
import { BuildingService } from '~/services/modules/stocks/building';
import { Building } from '~/models/modules/building';
import { environment } from 'environments/environment';
import { MultiSiteService } from '~/services/modules/common/multi-site.service';
import { SitesEnum } from '~/shared/enums/sites.enum';
import { MultiSiteAwareComponent } from '~/infrastructure/multi-site-aware.component';


@Component({
    selector: 'app-upsert',
    templateUrl: './upsert.html',
    styleUrls: ['./upsert.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class BuildingUpsertComponent extends MultiSiteAwareComponent implements OnInit, OnDestroy, AfterContentChecked {

  // _acountsitelist :boolean;
  _kendoTabStripPosition: TabPosition = 'left';
  _innerWidth: any;
  _hiddenWindow: any;
  _maximized: any;
  _storagePath: string;
  _theme: string;
  _AddressFiltered: any[];
  _addres: any[];
  _formGroup: FormGroup;
  _active: boolean;
  _isAutoGeneratingNumber: boolean;
  _currentType: string;
  _invalidForm: boolean;
  form: LocationSummary;
  _canEditLocationType: boolean = true;
  _buildingCode = new FormControl();
  _pageState: PageState;
  _showCirclesForm: boolean;
  _tooltipVisibilityUpsert: boolean = true;
  _tooltipVisibilityForm: boolean = true;
  _addClassActive: boolean = false;
  _isCustomfieldsFormValue: boolean = false;
  _isAddTabFormValue: boolean = false;
  _isRenameFormValue: boolean = false;
  _selectedTabId: number;
  _editFormActive: boolean;
  _customFields: CustomFieldSummary[][] = [];
  _page = 'building';
  _permissionScope = 'building';
  _customTabs: any;
  _customFieldsValue: any = [];
  _customValidation: any[] = [];
  _additionalErrors: any[] = [];
  _gridFieldText: GridFieldTextSummary[];
  _language: string = 'en';
  _isRenameLabel: boolean = false;
  _selectedLabelObjectCode: any;
  _isRenameCustomFormValue: boolean = false;
  _selectedLabelId: number;
  _customFieldsDictionary: { [key: string]: string } = {};
  _selectedAccountIds: any[] = [];
  _custominvalidForm: boolean;
  _invalidSubmit: boolean;
  _systemFields: Array<any> = [];
  _editedSystemFields: Array<any> = [];
  _index: number;
  _userNewDataTabs: Array<any> = [];
  _dataTabs: Array<any> = [];
  _dataTabsSelected: Array<any> = [];
  _orderingTabsForm: boolean = false;
  _gridFieldAuth: GridFieldAuthorization[];
  _isMandatory: boolean = false;
  _requiredFields: Array<any> = [];
  _requiredFieldNames: Array<any> = [];
  _SiteFiltered: any[];
  _isEditForms: boolean = false;
  _addressFiltered: any[];
  openfromlist: any = false
  public _donutChartSmall: any[] = [
    {
      data: [{
        category: 'Site 1',
        value: 120,
        color: '#fff6d9',
        colorLabel: '#ae8d2a',
        font: '10px -apple-system, BlinkMacSystemFont'
      }, {
        category: 'Site 2',
        value: 90,
        color: '#f2e2b1',
        colorLabel: '#ae8d2a',
        font: '10px -apple-system, BlinkMacSystemFont'
      }],
      sum: 210,
      title: 'DC Health'
    },
    {
      data: [{
        category: 'Site 1',
        value: 30,
        color: '#e7e0fc',
        colorLabel: '#321982',
        font: '10px -apple-system, BlinkMacSystemFont'
      }, {
        category: 'Site 2',
        value: 40,
        color: '#d1c7f0',
        colorLabel: '#321982',
        font: '10px -apple-system, BlinkMacSystemFont'
      }, {
        category: 'Site 3',
        value: 120,
        color: '#b3a5e3',
        colorLabel: '#321982',
        font: '10px -apple-system, BlinkMacSystemFont'
      }],
      sum: 180,
      title: 'Safe Workplace'
    },
    {
      data: [{
        category: 'Site 1',
        value: 30,
        color: '#e5fadd',
        colorLabel: '#458032',
        font: '10px -apple-system, BlinkMacSystemFont'
      }, {
        category: 'Site 2',
        value: 120,
        color: '#abd59d',
        colorLabel: '#458032',
        font: '10px -apple-system, BlinkMacSystemFont'
      }],
      sum: 150,
      title: 'District Logistics Center'
    }
  ];

  public _donutChartLarge: any[] = [
    {
      data: [{
        category: 'Site 1',
        value: 30,
        color: '#e5fadd',
        colorLabel: '#458032',
        font: '15px -apple-system, BlinkMacSystemFont'
      }, {
        category: 'Site 2',
        value: 120,
        color: '#abd59d',
        colorLabel: '#458032',
        font: '15px -apple-system, BlinkMacSystemFont'
      }],
      sum: 150,
      title: 'District Logistics Center'
    }
    ,
    {
      data: [{
        category: 'Site 1',
        value: 30,
        color: '#e7e0fc',
        colorLabel: '#321982',
        font: '15px -apple-system, BlinkMacSystemFont'
      }, {
        category: 'Site 2',
        value: 40,
        color: '#d1c7f0',
        colorLabel: '#321982',
        font: '15px -apple-system, BlinkMacSystemFont'
      }, {
        category: 'Site 3',
        value: 120,
        color: '#b3a5e3',
        colorLabel: '#321982',
        font: '15px -apple-system, BlinkMacSystemFont'
      }],
      sum: 180,
      title: 'Safe Workplace'
    },
    {
      data: [{
        category: 'Site 1',
        value: 120,
        color: '#fff6d9',
        colorLabel: '#ae8d2a',
        font: '15px -apple-system, BlinkMacSystemFont'
      }, {
        category: 'Site 2',
        value: 90,
        color: '#f2e2b1',
        colorLabel: '#ae8d2a',
        font: '15px -apple-system, BlinkMacSystemFont'
      }],
      sum: 210,
      title: 'DC Health'
    }
  ];
  _currentUser: UserSummary;

  okCloseSubscription: any = null;
  _deactivatedFieldsForm: boolean = false;
  _deactivatedFieldsGridData: any[] = [];
  _NOSActive: boolean = true;
  _INVENTORYIDActive: boolean = false;
  _BCActive: boolean = false;
  //StockNumberByDate: any;
  // InventoryidnumberInLocationByDate: any;
  // QtyItemPerCategoryByDate: any;

  getAddresses: any[] = [];
  getAddressesFiltered: any[] = [];
  getpicturefiles: any[] = [];
  getsite: any[] = [];
  getlistofBuilding: any[] = [];
  accountsiteCount: boolean = false;
  _isDialiog: boolean = false;
  _dialogComponentName: string;
  _dialogModel: any;
  _addresses: any[];
  buildingChart: Chart;
  _stockItemGridColumns: GridFieldSummary[];
  isOpenStockItemForm: boolean = false;
  reactivate: boolean = false;
  reactivateItem: any;
  isStockItemGridExpanded: boolean = true;
  isStockItemChartExpanded: boolean = true;
  _model: Building;
  reloadlist: any;
  //#region custom Fields Fix
  copyModelId: number;
  _customRequiredFields: Array<any> = [];
  //#endregion
  @ViewChild('kendo_tabstrip_wrapper') navTrigger: ElementRef;
  @ViewChild('kendo_BarcodeGen_Location_Type_ID') kendoBarcodeGenLocationTypeID: ElementRef;
  @ViewChild('locationTypeDescription') locationTypeDescription: ElementRef;
  @ViewChild('mainWindow') kendoMainWindow: ElementRef;
  @ViewChild('note') note: NoteComponent;
  @ViewChild('textarea_address') addressTextarea: ElementRef;
  @ViewChild('kendo_combo_addresses') kendoComboAddresses: ComboBoxComponent;
  //#region Multi Site Variables

  //#endregion


  constructor(

    private _addressesService: AddressesService,
    private getfilesService: FilesService,
    private _BuildingServices: BuildingService,
    private _fb: FormBuilder,
    private _themeManager: ThemeManagerService,
    private _layoutManager: LayoutManagerService,
    private _layoutComponent: LayoutComponent,
    private _gridLayoutManagerService: GridLayoutManagerService,
    private _barcodeGeneratorsService: BarcodeGeneratorsService,
    private _securityService: SecurityService,
    private _customFieldsService: CustomFieldsService,
    private _gridFields: GridFieldsService,
    public cdRef: ChangeDetectorRef,
    public _stockItemsService: StockItemsService,
    private _sharedService: SharedService,
    private _multiSitesService: MultiSiteService
  ) {
    super();
    this._getdata();

    this._themeManager.themeChange.subscribe((data) => {
      this._theme = data;
    });
    this._layoutManager.applyOverly();
    this._currentUser = this._securityService.currentUser;

    // this.loadCustomFields(this._model?.id?.toString());
    this.loadLabels();


    this._customFieldsService
      .getDeactivatedCustomFields('stock')

      .subscribe((data: Array<any>) => {
        this._deactivatedFieldsGridData = data.filter(x => x.formTab.page === this._page);
      });


    if (this._model.id) {
      // this._locationTypesService.getStockNumberByDate(this._model.id).subscribe((x: any) => {
      //   this.StockNumberByDate = x;
      // });


      // this._locationTypesService.getInventoryidnumberInLocationByDate(this._model.id).subscribe((x: any) => {
      //   this.InventoryidnumberInLocationByDate = x;
      // });

      // this._locationTypesService.getQtyItemPerCategoryByDate(this._model.id).subscribe((x: any) => {
      //   this.QtyItemPerCategoryByDate = x;
      // });
    }

    this.getAuth();
    //#region address Subscription
    this._addressesService.AddressAdded.subscribe((address: any) => {


      if (!this.getAddresses.find(x => x.id == address.id)) {
        this.getAddresses.push(address);
        this.getAddressesFiltered = this.getAddresses;
      }
      this._formGroup.get('addressid').setValue(address);

    })
    this._addressesService.AddressUpdated.subscribe((address: any) => {
      var UpdatedRecord = this.getAddresses.find(x => x.id == address.id);
      if (UpdatedRecord) {
        var Index = this.getAddresses.indexOf(UpdatedRecord);
        if (Index != -1) {
          this.getAddresses[Index] = address;
          this.getAddressesFiltered = this.getAddresses;
          this._formGroup.get('addressid').setValue(address);
        }

      }

    });
    //#endregion
  }

  _getdata() {
    this._model = this._sharedService.model && this._sharedService.model.model ? this._sharedService.model.model : null;
    this._pageState = this._sharedService.model && this._sharedService.model.pageState ? this._sharedService.model.pageState : null;
    this._active = true;
    this.openfromlist = this._sharedService.model.openfromlist;
    if (this._pageState === (PageState.ADD || PageState.COPY) && this._model && this._model.id > 0) {
      this.copyModelId = this._model.id;
      this._model.id = null;
      // this._model.code = null;
    }


    if (this._model && this._model.id) {
      this.LoadBuildingChart();
    }
    if (this._model && this._model.site) {
      this._loadSitesAndInitDD(true, this._model.site);
    }
    else {
      this._loadSitesAndInitDD();
    }
  }

  _handleAddressFilter(value: any) {
    this.getAddressesFiltered = this.getAddresses.filter(
      (s) => s.name.toLowerCase().indexOf(value.toLowerCase()) !== -1
    );
  }


  LoadBuildingChart() {
    this._BuildingServices.GetBuildingChart(this._model.id)
      .pipe()
      .toPromise()
      .then(async (data: any) => {
        this.buildingChart = data;
      });

    this._gridFields
      .getGridFieldsByPage('stockItems')

      .subscribe((data: any) => {
        this._gridLayoutManagerService.setGridColumnSubjects('stockItems', data);
        this._stockItemGridColumns = data;
      });

  }


  OnOpenStockItemForm(event: any) {
    if ((event.target as HTMLElement).tagName != 'DIV')
      this.isOpenStockItemForm = true;
  }

  OnCloseStockItemForm() {
    this.isOpenStockItemForm = false;
  }


  _getStockItemByLocationType = (params?: any, model?: any): Observable<DataWithPagingMetadata<any>> => {
    return this._stockItemsService.GetStockItemByLocationType(this._model.id);
  }


  ngAfterContentChecked(): void {
    this.cdRef.detectChanges();
  }


  ClosePopup(event: boolean) {
    if (event == true) {
      this._closeCustomFields();
    }
  }

  _onEditFields() {
    if (!this._currentUser.isEnterprise) {
      this._pageState = PageState.EDIT_FIELDS;
    } else {
      this._editFormActive = true;
      this._isCustomfieldsFormValue = true;
    }
  }
  _NOSTabClick() {

    this._NOSActive = true;
    this._INVENTORYIDActive = false;
    this._BCActive = false;
  }
  _INVENTORYIDTabClick() {
    this._NOSActive = false;
    this._INVENTORYIDActive = true;
    this._BCActive = false;
  }
  _BCTabClick() {
    this._NOSActive = false;
    this._INVENTORYIDActive = false;
    this._BCActive = true;
  }

  _viewInactiveFields() {
    this._customFieldsService
      .getDeactivatedCustomFields('stock')

      .subscribe((data: Array<any>) => {
        this._deactivatedFieldsGridData = data.filter(x => x.formTab.page === this._page);
      });
    this._deactivatedFieldsForm = true;
  }
  _closeInactiveFields() {
    this._deactivatedFieldsForm = false;
  }

  _reactivate(item: any) {

    this.reactivateItem = item;
    this.reactivate = true;
    this._sharedService.okCloseClicked.subscribe((data: boolean) => {
      if (data && this.reactivate) {
        this.reactivate = false;
        this._customFieldsService.reactivateCustomField(this.reactivateItem.id, item)

          .subscribe((response: any) => {
            if (response != null && response['message'] != null) {
              this._layoutComponent.openPopup({
                title: 'Alert',
                message: response['message'],
                withoutConfirm: true
              });
              if (response['close'] != null) {
                if (response['close'] == true) {
                  // this.loadCustomFields(this._model?.id?.toString());
                  this.getSystemFieldsAndCustomFields();
                  this._deactivatedFieldsForm = false;
                } else {
                  return;
                }
              }
            }
            this._deactivatedFieldsForm = false;
          });
        this._deactivatedFieldsForm = false;
      } else {
        this.reactivate = false;
      }
    });


    this._layoutComponent.openPopup({
      title: 'Notification',
      message: 'Are you sure you want to Reactivate ' + item.name
    });
    //this.loadCustomFields(this._model?.id?.toString());
    this.getSystemFieldsAndCustomFields();
  }

  _addNewTab() {
    this._editFormActive = true;
    this._isAddTabFormValue = true;
    this._isRenameLabel = false;
    this._selectedLabelId = null;
  }
  _addNewField(tabId: number) {
    this._selectedTabId = null;
    this._selectedTabId = tabId;
    this._editFormActive = true;
    this._isCustomfieldsFormValue = true;
    this._isRenameLabel = false;
  }
  _openCustomRenameForm(customFieldId: number, tabId: number) {
    this._selectedLabelId = customFieldId;
    this._selectedTabId = tabId;
    this._editFormActive = !isNaN(customFieldId);
    this._isRenameFormValue = !isNaN(customFieldId);
    this._isRenameCustomFormValue = !isNaN(customFieldId);
    this._isRenameLabel = false;
    this._isMandatory = false;
  }
  _openRenameForm(objectCode: string, isMandatory: boolean = false) {
    this._selectedLabelObjectCode = objectCode; //todo send system field label id
    //return; //open form once label id is set

    this._editFormActive = true;
    this._isRenameFormValue = true;
    this._isRenameCustomFormValue = false;
    this._isRenameLabel = true;
    this._isMandatory = isMandatory;
  }
  _returnAdNew() {
    this._pageState = PageState.ADD;
  }
  _closeCustomFields() {
    this._editFormActive = false;
    this._isCustomfieldsFormValue = false;
    this._isAddTabFormValue = false;
    this._isRenameFormValue = false;
    //this.loadCustomFields(this._model?.id?.toString());
    this.getSystemFieldsAndCustomFields();
    this.loadLabels();
    this.getFormTabs();
    this.getAuth();
  }
  ngOnInit() {
    this._initForm();
    if (this._pageState == PageState.ADD) {
      // setTimeout(() => {
      //   this.kendoBarcodeGenLocationTypeID.nativeElement.focus();
      // }, 500);
    }


    this._storagePath = environment.api.urls.enterpriseApi + '\\';

    this.getFormTabs();
    //this.getSystemFields();
    this.getSystemFieldsAndCustomFields();
    this.getAddressCompoGrid();
    this.getpicturefilesCompoGrid();
    //this.getBuildingCompoGrid();
  }


  _barcodeSubmited() {
    //this._buildingCode.setValue(this._formGroup.get('code').value);
    if (this._pageState == PageState.ADD) {
      // setTimeout(() => {
      //   this.locationTypeDescription.nativeElement.focus();
      // });
    }
  }
  _generateBarcodeClick() {
    //this.runGenerateBarcode();
  }
  _openCirclesForm() {
    this._showCirclesForm = true;
    this._tooltipVisibilityUpsert = false;
  }
  _closeCirclesForm() {
    this._showCirclesForm = false;
    this._tooltipVisibilityUpsert = true;
  }

  _edit() {
    this._pageState = PageState.EDIT;
  }
  private runGenerateBarcode() {
    let counter = 1;
    this.generateBarcode(counter)
      .subscribe((data: any) => {
        this._buildingCode.setValue(data.result.toString());
        this._formGroup.patchValue({
          // code: data.result.toString()
        });
        if (this._pageState == PageState.ADD) {
          setTimeout(() => {
            this.locationTypeDescription.nativeElement.focus();
          });
        }
      });
  }
  private generateBarcode(quantity: number) {
    return this._barcodeGeneratorsService.getBarcode('building', quantity);
  }

  _onStateChanges(e: any) {
    var element: any = this.kendoMainWindow;
    if (e === 'minimized') {
      element.el.nativeElement.classList.remove('fullWidthFormForm');
    }
    else if (e === 'maximized') {
      element.el.nativeElement.classList.remove('fullWidthFormForm');
    }
    else if (e === 'default') {
      element.el.nativeElement.classList.add('fullWidthFormForm');
    }
  }

  getpicturefilesCompoGrid() {
    return this.getfilesService
      .getPictureFilesSummary()
      .subscribe((data: any) => {
        this.getpicturefiles = data;
      });
  }
  _handleAddressesFilter(value: any) {
    this.getAddressesFiltered = this.getAddresses.filter(
      (s) => s.name.toLowerCase().indexOf(value.toLowerCase()) !== -1
    );
  }

  getAddressCompoGrid() {
    return this._addressesService
      .getAddressesSiteBuildingSummary()
      .subscribe((data: any) => {
        this.getAddresses = data.addressSummaryDto;
        this.getAddressesFiltered = data.addressSummaryDto;
        this.getsite = data.siteDto;
        this.accountsiteCount = this.getsite.length > 1 ? true : false;
      });
  }

  getBuildingCompoGrid() {
    return this._BuildingServices
      .getListOfBuilding()
      .subscribe((data: any) => {
        this.getlistofBuilding = data;
      });
  }
  public virtual: VirtualizationSettings = {
    itemHeight: 36, // @progress/kendo-theme-default default item height
  };
  _handleAddressesChange(value: any) {
    //this.addressTextarea.nativeElement.value = this._fillAddressDetails(value);
    setTimeout(() => {
      //  this.kendoComboAddresses.toggle(false);
    });
  }
  submodel: any;
  //   _openForm(componentName: string,) {
  //     this._isDialiog = true;
  //     this._dialogComponentName = componentName;
  //      this.submodel = this._sharedService.model.submodel ;
  //     this._dialogModel = { model: {}, pageState: PageState.ADD , reload: 'model' };
  // }

  _openForm(componentName: string, maindailog: string = null) {

    if (this._pageState === PageState.VIEW) return
    this._isDialiog = true;
    this._dialogComponentName = componentName;
    this._dialogModel = { model: {}, pageState: PageState.ADD, reload: 'model', submodel: maindailog };
  }

  ngOnDestroy() {
    this._layoutManager.removeOverlay();
  }

  @HostListener('window:resize', ['$event'])
  onResize(event: any) {
    this._innerWidth = window.innerWidth;
    if (this._innerWidth > 450) {
      this._hiddenWindow = 'hidden';
      this._maximized = 'maximized';
    } else {
      this._hiddenWindow = '';
      this._maximized = 'default';
    }
    let windowSize = window.innerWidth;

    if (windowSize <= 991) {
      this._kendoTabStripPosition = 'top';
    } else {
      this._kendoTabStripPosition = 'left';
    }
  }

  _onTabSelect(e: any) {

    this._mobileMenuToggle();
  }

  _mobileMenuToggle() {
    let mobiletabstrip = this.navTrigger.nativeElement.querySelector('ul');
    mobiletabstrip.classList.toggle('visibletab');
  }

  _onSave(e: any) {
    this.submit(e);
  }

  modelupdatedlookup: any;
  _onCancel() {
    this._closeForm(this._sharedService.model.reload != undefined ? this.modelupdatedlookup : '');
  }



  _closeForm(poModel: any = null) {

    this.reloadlist = this._sharedService.model.reload;
    this.submodel = this._sharedService.model.submodel;

    if (this.submodel !== undefined && this.reloadlist === undefined && this.submodel !== null) {
      this.reloadlist = this.submodel.split('-', 1);
    }
    if (this.openfromlist === true) {
      this.reloadlist = undefined;
    }

    var closeComponent = {
      component: 'building',
      isClosed: true,
      response: this.reloadlist === undefined ? null : poModel
    };

    this._active = false;
    this._gridLayoutManagerService.setGridDataSubjects('building');
    this._layoutManager.setFromChanged('building');
    this.ngOnDestroy();
    this._sharedService.closeDialog.emit(closeComponent);
    if (this.submodel === null || this.submodel === '')
      this._sharedService.model = {};

  }

  private _initForm() {
    this._formGroup = this._fb.group({
      // code: [this._model ? this._model.code : null, Validators.required],
      addressid: [this._model ? this._model.address : null, Validators.required],
      fileid: [this._model ? this._model.file : null, Validators.required],
      site: [this._model ? this._model.site : null, !this._currentUser.isEnterprise ? Validators.required : null],
      description: [this._model ? this._model.description : null, Validators.required],
    });
    if (this._model != null && this._model.id != null && [1, 2, 3].includes(this._model.id)) { //prevent saving system location types: stationary, moving and pallet
      this._canEditLocationType = false;
    }
  }

  _editBuilding = (params?: any) => {
    return this._BuildingServices.getBuildingByID(params)

      .subscribe((model) => {
        this.openUpsert(this._page, model, PageState.EDIT);
      });
  }

  private submit = (e: string) => {

    if (!this._currentUser.isEnterprise && !this._siteSelected && this.isLoggedInAllSites) {
      this._layoutComponent.openPopup({
        title: 'Validation',
        message: 'Please select site to continue.',
        withoutConfirm: true
      });
      return false;
    }
    this._formGroup.controls['site'].setValue(this._siteSelected);
    // if (!this.accountsiteCount)
    // {
    //   this._formGroup.controls['siteid'].setErrors(null);
    // }
    if (this._formGroup.invalid && this._custominvalidForm) {
      this._invalidForm = true;
      this._invalidSubmit = true;
    } else if (this._formGroup.invalid) {
      this._invalidForm = true;
    } else if (this._custominvalidForm) {
      this._invalidSubmit = true;
    } else {
      // work with custom fields
      if (this._customFieldsValue) {
        // const entries = Object.entries(this._customFieldsValue);
        // for (const [index, [key, value]] of entries.entries()) {
        //   this._customFieldsDictionary[key] = `${value}`;
        // }
        this._customFieldsValue.forEach((elementy: any) => {
          this._customFieldsDictionary[elementy.Key] = elementy.Value;
        });
      }
      //
      this._invalidForm = false;
      this._invalidSubmit = false;
      const model = this._formGroup.value;

      model['addressid'] = model.addressid.id ?? model.addressid;
      model['fileid'] = model.fileid.id ?? model.fileid;
      model['siteid'] = this._siteSelected?.id;
      model['id'] = this._model.id;
      //model['code'] = model.code ;
      model['customFieldsValue'] = this._customFieldsDictionary;
      if (!this._model || !this._model.id) {
        this._BuildingServices
          .createBuilding(model)

          .subscribe((response: any) => {
            if (response != null && response['message'] != null) {
              this._model.id = response.responseId;
              this._layoutComponent.openPopup({
                title: 'Alert',
                message: response['message'],
                withoutConfirm: true
              });
              if (response['close'] != null) {
                if (response['close'] == true) {
                  if (response['extraData'] && response['extraData'].data)
                    this._BuildingServices.BuildingAdded.emit(response['extraData'].data);
                  if (e === 'saveAndClose') {
                    model.id = this._model.id;
                    this._closeForm(model);
                  }
                  else if (e === 'saveAndCopy') {
                    this._formGroup.controls.description.setValue(null);
                    this._model.id = null;
                  }
                  else if (e === 'saveAndNew') {
                    this._initForm();
                    this.openUpsert(this._page, {}, PageState.ADD);
                    this._model.id = null;
                    this._formGroup.reset();
                  }
                  else if (e === 'save' || this.reloadlist != undefined) {
                    model.id = response.responseId;
                    this.modelupdatedlookup = model;
                    if (this.canAccess('building', 'update')) {
                      if (this._pageState == PageState.ADD) {
                        this._editBuilding(model.id);
                      }
                    }

                  }
                } else {
                  return;
                }
              }
            }

          });
        //================================================UPDATE BUILDING ==================================
      } else {
        this._BuildingServices
          .updateBuilding(model)

          .subscribe((response: any) => {
            if (response != null && response['message'] != null) {
              this._layoutComponent.openPopup({
                title: 'Alert',
                message: response['message'],
                withoutConfirm: true
              });
              if (response['close'] != null) {
                if (response['close'] == true) {
                  if (response['extraData'] && response['extraData'].data)
                    this._BuildingServices.BuildingUpdated.emit(response['extraData'].data);
                  if (e === 'saveAndClose') {
                    this._closeForm();
                  }
                  else if (e === 'saveAndCopy') {
                    this.copyModelId = this._model.id;
                    this._model.id = null;
                    this._formGroup.controls.description.setValue(null);
                    this._pageState = PageState.ADD;
                    this.loadCustomFields();

                  }
                  else if (e === 'saveAndNew') {
                    this.openUpsert(this._page, {}, PageState.ADD);
                    this._model.id = null;
                    this._formGroup.reset();


                  }
                } else {
                  return;
                }
              }
            }
          });
      }
    }
  }


  private loadCustomFields(entityId?: string) {

    entityId = this.copyModelId?.toString() ?? this._model?.id?.toString();
    this._customFieldsService
      .getCustomFields('stock', this._page, entityId)

      .subscribe((data) => {
        if (this._model != null && this._model.id != null || this.copyModelId != null) {
          let that = this;
          data.map(function (x) {
            x.entityId = that._model.id ?? that.copyModelId;
          });
        }
        var tabIds = data.map(item => item.formTabId)
          .filter((value, index, self) => self.indexOf(value) === index);

        const grouped = this.groupBy(data, (item: { formTabId: any }) => item.formTabId);
        let that = this;
        tabIds.forEach(function (formTabId) {

          that._customFields[formTabId] = grouped.get(formTabId);
        });
        if (this.copyModelId) {
          let CustomFieldsDataForCopy: any = {};
          grouped.forEach(element => {
            element.forEach((value: any) => {

              let _cutomfieldData = value.customFieldsData?.find((f: any) => f.entityId == entityId);
              CustomFieldsDataForCopy[value.name] = _cutomfieldData?.value ?? null;
              if (value.customFieldType.type.toLowerCase() == 'date' && CustomFieldsDataForCopy[value.name])
                CustomFieldsDataForCopy[value.name] = new Date(CustomFieldsDataForCopy[value.name]);
              if (value.customFieldType.type.toLowerCase() == 'numeric' && CustomFieldsDataForCopy[value.name])
                CustomFieldsDataForCopy[value.name] = parseFloat(CustomFieldsDataForCopy[value.name]);
            });
            this._customFieldsValueChanges(CustomFieldsDataForCopy, null);

          });
        }
        this.setMandatoryFields();
      });

    this._customFieldsService
      .getFormTabsByPage(this._page)

      .subscribe((data: any) => {
        //get custom tabs first
        this._customTabs = data.filter((x: { isCustom: boolean }) => x.isCustom == true);

      });
  }

  groupBy(list: any[], keyGetter: any) {
    const map = new Map();
    list.forEach((item) => {
      const key = keyGetter(item);
      const collection = map.get(key);
      if (!collection) {
        map.set(key, [item]);
      } else {
        collection.push(item);
      }
    });
    return map;
  }


  // _customFieldsValueChanges(customFieldsValue: any, tabId: number) {

  //   Object.keys(customFieldsValue).forEach(key => {
  //     if (customFieldsValue[key] == null || customFieldsValue[key] == 'null') {
  //       customFieldsValue[key] = '';
  //     }
  //     if (this._customFields[tabId].find(x => x.name == key).entityId == undefined) {//new mode, custom field data not added yet
  //       this._customFields[tabId].find(x => x.name == key).entityId = -1;
  //       this._customFields[tabId].find(x => x.name == key).customFieldsData.push({ id: -1, value: 'null', entityId: -1,customFieldId:-1 });
  //     }
  //     var customFieldData = this._customFields[tabId].find(x => x.name == key).customFieldsData.find(x => x.entityId == this._customFields[tabId].find(x => x.name == key).entityId);
  //     if (customFieldData != undefined) {
  //       customFieldData.value = customFieldsValue[key];
  //     }
  //   });
  //   this._customFieldsValue = customFieldsValue;
  // }
  _customFieldsValueChanges(customFieldsValue: any, tabId: number) {

    Object.keys(customFieldsValue).forEach((key) => {
      let customObject = {
        Key: key,
        Value: customFieldsValue[key],
      };
      let item = null;
      this._customFieldsValue.forEach((elementz: any) => {
        if (elementz.Key == key) {
          item = elementz;
        }
      });
      if (item != null) {
        let index = this._customFieldsValue.indexOf(item);
        if (index != -1) {
          this._customFieldsValue.splice(index, 1);
        }
      }
      var requiredCustomerField = this._customValidation.find(
        (x: any) => x.name == key
      );
      if (requiredCustomerField) {
        let item2 = null;
        this._customValidation.forEach((element: any) => {
          if (element.name == key) {
            item2 = element;
          }
        });
        if (item2 != null) {
          let index2 = this._customValidation.indexOf(item2);
          if (index2 != -1) {

            this._customValidation[index2].value = customObject.Value;
          }

        }
      }
      this._additionalErrors = [];
      if (this._customValidation.find((x: any) => !x.value)) {
        this._additionalErrors.push("Additional Error");
        this._additionalErrors = [];
      }

      this._customFieldsValue.push(customObject);
    });
  }

  _removeCustomField(customFieldId: number) {
    for (var i = 1; i <= this._customFields.length; i++) {
      if (this._customFields[i] != null) {
        if (this._customFields[i].findIndex(x => x.id == customFieldId) != -1) {
          this._customFields[i] = this._customFields[i].filter(x => x.id != customFieldId);
          return;
        }
      }
    }
  }

  _deactivateTab(tabId: number, page: string) {

    let model: any = {
      customFieldEntityId: page == 'locationTypes' ? 1 : 2,
      page: this._page,
      accountIds: this._selectedAccountIds,
    };
    this._customFieldsService
      .deleteCustomTab(tabId, model)

      .subscribe((response: any) => {
        if (response != null && response['message'] != null) {
          this._customFieldsService
            .getFormTabsByPage(this._page)

            .subscribe((data: any) => {
              //get custom tabs first
              this._customTabs = data.filter((x: { isCustom: boolean }) => x.isCustom == true);
            });
          this._layoutComponent.openPopup({
            title: 'Alert',
            message: response['message'],
            withoutConfirm: true
          });
          if (response['close'] != null) {
            if (response['close'] == true) {
            } else {
              return;
            }
          }
        }
      });

  }

  private loadLabels() {
    this._gridFields.getGridFieldTextLabelByPage(this._page, this._language)

      .subscribe((data: GridFieldTextSummary[]) => {
        this._gridFieldText = data;
        this._initForm();
      });
  }

  getLabel(objectCode: any) {
    if (this._gridFieldText) {
      if (this._gridFieldText.find(({ gridFieldDefinition }) => gridFieldDefinition?.objectCode === objectCode))
        var result = this._gridFieldText.find(({ gridFieldDefinition }) => gridFieldDefinition?.objectCode === objectCode);
      else
        result = null;

      return result ? result : null;
    }
  }

  formStatus(isInvalid: boolean) {
    this._custominvalidForm = isInvalid;
  }


  CheckIfWeAreInEditMode() {
    var isEditMode: boolean = false;
    if (this._pageState == PageState.EDIT) {
      isEditMode = true;
    }

    return isEditMode;
  }


  _reorderingtabs() {
    this._orderingTabsForm = true;
  }
  _closeOrderingTabsForm() {
    this._orderingTabsForm = false;
    this._dataTabsSelected = this._userNewDataTabs;
  }


  _comboValueChange(e: any, i: number) {
    if (this._dataTabsSelected.find(x => x.order == i + 1)) {
      this._userNewDataTabs.find(x => x === this._dataTabsSelected.find(x => x.order == i + 1)).order =
        this._dataTabsSelected.find(x => x.name === e.name).order;
    }
    this._userNewDataTabs.find(obj => obj.name == e.name).order = i + 1;
    this._dataTabsSelected = this._dataTabsSelected.filter(obj => obj !== e);
  }

  _onSaveTabOrdering() {
    this._gridFields.updateFormTabsReorder(this._userNewDataTabs)

      .subscribe((x: any) => {
        this._dataTabs = x;
        this._dataTabsSelected = x;
        this._closeOrderingTabsForm();
      });
  }

  getFormTabs() {
    this._gridFields.getformTabsByPage(this._page)

      .subscribe((x: any) => {
        this._dataTabs = x;
        this._dataTabsSelected = x;
        this._userNewDataTabs = x;
        //this.sortProduct(p => p.order, "ASC");
      });
  }

  getAuth() {
    this._gridFields.getFieldsAuthorization(this._page, this._currentUser.appRole.id)

      .subscribe((x: GridFieldAuthorization[]) => {
        this._gridFieldAuth = x;
      });
  }

  getAuthByLabel(objectCode: any) {
    if (this._gridFieldAuth) {
      if (this._gridFieldAuth.find(({ gridFieldDefinition }) => gridFieldDefinition?.objectCode === objectCode))
        var result = this._gridFieldAuth.find(({ gridFieldDefinition }) => gridFieldDefinition?.objectCode === objectCode);
      else
        result = null;

      return result ? result : new GridFieldAuthorization();
    }
  }

  getSystemFields() {
    this._gridFields.getSystemFieldsByPage(this._page)

      .subscribe((x: any) => {
        this._systemFields = x;
        this._editedSystemFields = x;
      });
  }
  getSystemFieldsAndCustomFields() {
    this._gridFields.getSystemFieldsByPage(this._page)

      .subscribe((x: any) => {
        this._systemFields = x;
        this._editedSystemFields = x;
        this.loadCustomFields(this._model?.id?.toString());
        //this.setMandatoryFields();
      })

  }
  //#region  setMandatoryFields
  requiredSystemTabs: any = [];
  setMandatoryFields() {
    this._requiredFieldNames = [];
    this._requiredFields = [];
    this.requiredSystemTabs = [];
    setTimeout(() => {
      for (let item of this._systemFields) {
        if (item.gridFieldText.isRequired) {
          this._requiredFields.push(item);
        }
      }

      for (let item2 of this._customFields) {
        if (item2) {
          for (let item3 of item2) {
            if (item3.isRequired) {
              this._requiredFields.push(item3);
            }
          }
        }
      }
      this._requiredFields.forEach(element => {
        if (!element.isCustomField && element.isCustomField == null) {
          var tabName = element.formTab;
          this._requiredFieldNames.push(tabName);
        }
        else {
          if (element.formTabId) {
            let SystemFieldTab = this._dataTabs.find(x => x.id == element.formTabId);
            if (SystemFieldTab)
              this.requiredSystemTabs.push(SystemFieldTab);
          }
        }
      });
      if (this.navTrigger) {
        let tabElementList = this.navTrigger.nativeElement.querySelector('ul');
        Array.from(tabElementList.children).forEach((child: any) => {

          child.classList.remove('mendatoryTab');
        });
        Array.from(tabElementList.children).forEach((child: any) => {

          if (this._requiredFieldNames.find(x => x.name === child.firstChild.innerText && (x.page ? x.page == this._page : x.formtab.page == this._page))) {
            child.classList.add("mendatoryTab")
          }
          if (
            this.requiredSystemTabs.find(
              (x: any) =>
                x.name === child.firstChild.innerText
            )
          ) {
            child.classList.add('mendatoryTab');
          }
        });
      }
      this._requiredFields.forEach((element) => {
        if (element.customFieldType) {
          this._customRequiredFields.push(element);
          let thisvalue =
            element.customFieldsData.filter(
              (x: any) => x.entityId == (this._model.id > 0 ? this._model.id : this.copyModelId)
            ).length > 0
              ? element.customFieldsData.filter(
                (x: any) => x.entityId == (this._model.id > 0 ? this._model.id : this.copyModelId)
              )[0].value
              : '';
          this._customValidation.push({
            name: element.name,
            value: thisvalue,
            tabName: element.formTab?.name,
          });
        }
      });


    }, 500);

  }
  //#endregion

  _onEditForms() {
    this._isEditForms = true;
  }

  _onCloseEditForms(event: boolean) {
    this._isEditForms = event;
  }

  openUpsert(componentName: string, model: any, pageState: PageState) {
    this._isDialiog = true;
    this._dialogComponentName = componentName;
    this._dialogModel = { model, pageState };
  }


  _closeDialog(event: any) {
    if (event?.response) {

      if (event.component == 'addresses') {
        // this.getAddressCompoGrid();
        // this._formGroup.get('addressid').setValue(event.response);
        this._isDialiog = event.open;
      }
      if (event.component == 'files') {
        this.getpicturefilesCompoGrid();
        this._formGroup.get('fileid').setValue(event.response);
        this._isDialiog = event.open;
      }
    } else {
      this._isDialiog = event;
    }
  }



  ExpandCollapseStockItemGrid(isExpand: boolean) {
    this.isStockItemGridExpanded = !isExpand;
  }


  ExpandCollapseStockItemChart(isExpand: boolean) {
    this.isStockItemChartExpanded = !isExpand;
  }




  getStockItemLeadsString(stockItemLeads: any) {
    let leads = '';
    let counter = 0;
    stockItemLeads.forEach((element: any) => {
      if (counter > 0) {
        leads += ', ';
      }
      leads += element.stockitemleadtime;
      counter++;
    });
    return leads;
  }


  getStockImage(stockItemFiles: any) {
    let files = '';
    let counter = 0;
    stockItemFiles.forEach((element: any) => {
      if (counter > 0) {
        files += ', ';
      }
      files += element.file.thumbnail;
      counter++;
    });
    return files;
  }

  getCategoryImage(categoryFiles: any) {
    let catfiles = '';
    let counter = 0;
    categoryFiles.forEach((element: any) => {
      if (counter > 0) {
        catfiles += ', ';
      }
      catfiles += element.file.thumbnail;
      counter++;
    });
    return catfiles;
  }

  getVendors(vendors: any) {
    let vendor = '';
    let counter = 0;
    vendors.forEach((element: any) => {
      if (counter > 0) {
        vendor += ', ';
      }
      vendor += element.vendorid;
      counter++;
    });
    return vendor;
  }

  getTimeUnitCode(vendors: any) {
    let vendor = '';
    let counter = 0;
    vendors.forEach((element: any) => {
      if (counter > 0) {
        vendor += ', ';
      }
      vendor += element.stockItemLeadid;
      counter++;
    });
    return vendor;
  }

  getTimeUnit(vendors: any) {
    let vendor = '';
    let counter = 0;
    vendors.forEach((element: any) => {
      if (counter > 0) {
        vendor += ', ';
      }
      vendor += element.stockitemleadinterval;
      counter++;
    });
    return vendor;
  }


  getSitesString(accountSites: any, isId: boolean) {
    let sites = '';
    let counter = 0;
    accountSites.forEach((element: any) => {
      if (counter > 0) {
        sites += ', ';
      }
      if (!isId) {
        if (element.site) {
          sites += element.site.name;
        } else {
          sites += 'All Sites';
        }
      }
      else {
        if (element.site) {
          sites += element.site.id;
        }
      }

      counter++;
    });
    return sites;
  }

  getAccountsString(accountSites: any) {
    let accounts = '';
    let counter = 0;
    accountSites.forEach((element: any) => {
      if (counter > 0) {
        accounts += ', ';
      }
      accounts += element.account.name;
      counter++;
    });

    return accounts;
  }

  canAccess(scope: string, operation: string): boolean {
    return this._securityService.hasPermission(null, `${scope}-${operation}`);
  }

  _hasCustomTabs() {
    return this._dataTabs.find((x: any) => x.isCustom);
  }

  //#region Multi Site Functions
  _loadSitesAndInitDD(IsEdit: boolean = false, SavedSite: any = null) {
    this._multiSitesService.getAllSites().subscribe((data: any) => {
      this._sites = data || [];
      this._sitesFiltered = this._sites;

      this.initAllSitesDropDown(IsEdit, SavedSite);

    });
  }
  initAllSitesDropDown(isEdit: boolean = false, SavedSite: any = null) {
    super.initAllSitesDropDown(isEdit, SavedSite);
  }
  //#endregion
}
